import React, { JSX } from 'react';
import {
  AppBar as MuiAppBar,
  AppBarProps as MuiAppBarProps,
  styled,
  Toolbar
} from '@mui/material';
import { NavToggle } from '@/components/navigation';
import { ToolbarSlotsPerRoute } from './ToolbarSlotsPerRoute';

interface StyledAppBarProps extends MuiAppBarProps {
  open: boolean;
  drawerWidth: number;
}

const StyledAppBar = styled(MuiAppBar, {
  shouldForwardProp: (prop) => prop !== 'open' && prop !== 'drawerWidth'
})<StyledAppBarProps>(({ theme, open, drawerWidth }) => ({
  transition: theme.transitions.create(['margin', 'width'], {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen
  }),
  ...(open && {
    width: `calc(100% - ${drawerWidth}px)`,
    marginLeft: `${drawerWidth}px`,
    transition: theme.transitions.create(['margin', 'width'], {
      easing: theme.transitions.easing.easeOut,
      duration: theme.transitions.duration.enteringScreen
    })
  })
}));

interface AppBarProps extends StyledAppBarProps {
  onToggleClick: () => void;
}

export const AppBar = ({
  onToggleClick,
  ...props
}: AppBarProps): JSX.Element => (
  <StyledAppBar elevation={0} position="fixed" {...props}>
    <Toolbar
      disableGutters
      variant="dense"
      style={{ justifyContent: 'space-between', alignItems: 'center' }}
    >
      <NavToggle onClick={onToggleClick} />
      <ToolbarSlotsPerRoute />
    </Toolbar>
  </StyledAppBar>
);
